import React, { useEffect } from "react";

const games = [
  { name: "Call of Duty League", logo: "/logos/cdl.webp", live: true },
  { name: "Valorant", logo: "/logos/valorant.svg", live: false },
  { name: "Counter-Strike 2", logo: "/logos/cs2.webp", live: false },
  { name: "League of Legends", logo: "/logos/lol.webp", live: false },
  { name: "Dota 2", logo: "/logos/dota2.webp", live: false },
  { name: "Overwatch 2", logo: "/logos/overwatch.webp", live: false },
  { name: "Rainbow Six Siege", logo: "/logos/r6.webp", live: false },
  { name: "Rocket League", logo: "/logos/rocketleague.webp", live: false },
  { name: "Halo", logo: "/logos/halo.webp", live: false },
];

export function GamesPage() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      },
      { threshold: 0.1 },
    );
    document
      .querySelectorAll(".animate-on-scroll")
      .forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page-content">
      <section className="hero is-medium about-hero">
        <div className="hero-body">
          <div className="container has-text-centered">
            <p className="about-hero-label">ESPORTS COVERAGE</p>
            <h1
              className="title is-2 has-text-white"
              style={{ fontWeight: 700, letterSpacing: "2px" }}
            >
              Games We <span style={{ color: "#6ee7b7" }}>Price</span>
            </h1>
            <p className="subtitle has-text-grey-light mt-3">
              Simulation-powered pricing across competitive esports titles
            </p>
          </div>
        </div>
      </section>

      <section className="section about-section">
        <div className="container">
          <div className="columns is-multiline is-centered">
            {games.map((game, i) => (
              <div key={game.name} className="column is-3">
                <div
                  className={
                    "game-card animate-on-scroll" +
                    (game.live ? " game-card-live" : " game-card-coming")
                  }
                  style={{ transitionDelay: `${i * 0.05}s` }}
                >
                  <div className="game-card-logo">
                    {game.logo ? (
                      <img src={game.logo} alt={game.name} />
                    ) : (
                      <span className="game-card-initial">
                        {game.name.charAt(0)}
                      </span>
                    )}
                  </div>
                  <p className="game-card-name">{game.name}</p>
                  {game.live ? (
                    <span className="game-card-badge game-card-badge-live">
                      LIVE
                    </span>
                  ) : (
                    <span className="game-card-badge game-card-badge-soon">
                      COMING SOON
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ backgroundColor: "#252535" }}>
        <div className="container has-text-centered">
          <h2 className="title is-3 has-text-white">
            Want us to cover your game?
          </h2>
          <p className="has-text-grey-light is-size-5 mb-5">
            We're expanding to new titles. If there's a game you'd like us to
            price, let us know.
          </p>
          <a href="/contact" className="button is-primary is-medium">
            Get In Touch
          </a>
        </div>
      </section>
    </div>
  );
}
